module.exports = __webpack_public_path__ + "img/25f6952.svg";